import { useId, useState } from 'react';
import type { ReactNode } from 'react';
import './Disclosure.css';

/**
 * Minimal branded accordion row — an uppercase trigger with a plus/minus glyph
 * and a height-animated panel (grid 0fr→1fr). Stack several inside a wrapper to
 * get the Saleroom detail page's Material / Size / Shipping dropdowns. Fully
 * keyboard- and screen-reader-accessible (button + aria-expanded + region).
 */
export function Disclosure({
  title,
  defaultOpen = false,
  children,
}: {
  title: string;
  defaultOpen?: boolean;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);
  const id = useId();
  return (
    <div className={`disclosure ${open ? 'disclosure--open' : ''}`}>
      <h3 className="disclosure__heading">
        <button
          type="button"
          id={`${id}-trigger`}
          className="disclosure__trigger"
          aria-expanded={open}
          aria-controls={`${id}-panel`}
          onClick={() => setOpen((o) => !o)}
        >
          <span className="disclosure__title">{title}</span>
          <span className="disclosure__icon" aria-hidden="true" />
        </button>
      </h3>
      <div
        id={`${id}-panel`}
        className="disclosure__panel"
        role="region"
        aria-labelledby={`${id}-trigger`}
      >
        <div className="disclosure__inner">{children}</div>
      </div>
    </div>
  );
}
